// Central school configuration — change here, reflects everywhere
export const SCHOOL = {
  name:    "SurSadhana Music Classes",
  tagline: "Sadhana · Sur · Samarpan",
  teacher: "Mansi Swarup Deshpande",
  phone:   "+91 83080 47545",
  email:   "mansideshpande@sursadhana.co.in",
  address: "D-703, Padmavati Hills, Bavdhan, Pune 411021",
};

// Day of the month by which monthly fees are due. Admin reports allow a grace
// period past this (FEE_LATE_AFTER_DAY in admin-panel.html) before counting a
// payment late, so this is the date students see, not the reporting cutoff.
export const FEE_DUE_DAY = 7;
